<div class="data-empty {{custClass}}">

  <img [src]="img" *ngIf="img" alt="">

  <h3>
    @if(title) { {{title}} }
    @else { {{'general.No Data Found' | translate}} }
  </h3>
  <p *ngIf="subTitle"> {{subTitle}}</p>
  <p *ngIf="desc">{{desc}}</p>
</div>
